import classNames from 'classnames';
import React, { memo, useCallback, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { getAuthorList, setScroll } from '../../actions/wallpaper';
import ScrollTop from '../../components/ScrollTop/ScrollTop';
import { CONTEXT } from '../../config';
import wpAuthorDefault from '../../static/wp_author_default.png';
import Blank from './Blank';
import styles from './WallPaperAuthorList.module.less';

const Author = memo(({ info = {} }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const handleClick = useCallback(() => {
    // 点击某个作者
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_AuthorMark',
        label: '',
        param2: {
          source: `Wallpaper_AuthorList`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          authorId: info.authorId,
          authorName: info.authorName,
        },
      }),
    );
    history.push(`${CONTEXT}/wpauthordetail?authorId=${info.authorId}`);
  });
  return (
    <div className={styles.author} onClick={handleClick}>
      <img src={info.headPortrait || wpAuthorDefault} alt="" className={styles.author_head} />
      <div className={styles.author_name}>{info.authorName}</div>
      <div className={styles.author_other}>
        <div className={styles.author_other_item}>{info.wallpaperCount || 0}&nbsp;作品</div>
        <div className={styles.author_other_item}>|</div>
        <div className={styles.author_other_item}>{info.collectCount || 0}&nbsp;收藏</div>
      </div>
    </div>
  );
});

const selectWpAuthorList = createSelector(
  state => {
    return state.wallpaper && state.wallpaper;
  },
  info => info.wpAuthorList,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectScroll = createSelector(
  state => state.wallpaper && state.wallpaper,
  info => {
    return info.scroll;
  },
);

export default memo(() => {
  const dispatch = useDispatch();
  const { action } = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const authorList = useSelector(selectWpAuthorList);
  const scrollInfo = useSelector(selectScroll);
  const [contentElHeight, setContentElHeight] = useState(0);

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Wallpaper_AuthorList`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
          },
        }),
      );
    };
  }, []);

  /**
   * PUSH 滚动到最顶端
   */
  useEffect(() => {
    const el = document.getElementById('container_content');
    if (action === 'PUSH') {
      el.scrollTo(0, 0);
    }
  }, []);
  useEffect(() => {
    const el = document.getElementById('container_content');
    if (el.scropTop > 0 && action === 'POP') {
      dispatch(
        setScroll({
          authorListScrollTop: 0,
        }),
      );
    }
  }, [authorList]);
  /**
   * POP 滚动到之前位置
   */
  useEffect(() => {
    const el = document.getElementById('container_content');
    if (contentElHeight && scrollInfo && scrollInfo.authorListScrollTop && action === 'POP') {
      if (contentElHeight <= scrollInfo.authorListScrollTop) {
        el.scrollTo(0, scrollInfo.authorListScrollTop - 20);
      } else {
        el.scrollTo(0, scrollInfo.authorListScrollTop);
      }
    }
  }, [contentElHeight]);

  useEffect(() => {
    // 更新页面 PV
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'P_Wallpaper_AuthorList',
        label: '',
        param2: {
          source: `Wallpaper_AuthorList`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: `Wallpaper_AuthorList`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, [dispatch]);

  // useEffect(() => {
  //   setContentElement(document.getElementById('container_content'));
  // }, [document.getElementById('container_content')]);

  // 获取全部作者列表
  useEffect(() => {
    if (action !== 'POP' || authorList.list.length === 0) {
      dispatch(
        getAuthorList({
          ...authorList.pagenation,
          skip: 0,
          refresh: true,
        }),
      );
    }
  }, []);

  const loadMore = useCallback(() => {
    if (!authorList.load) {
      dispatch(
        getAuthorList({
          ...authorList.pagenation,
          skip: authorList.list.length,
          refresh: false,
        }),
      );
    }
  });

  const handleSaveScrollTop = () => {
    const el = document.getElementById('container_content');
    dispatch(
      setScroll({
        authorListScrollTop: el && el.scrollTop,
      }),
    );
  };

  const handleMeasureHeight = useCallback(node => {
    if (node) {
      setContentElHeight(node.clientHeight);
    }
  }, []);

  return (
    <div onClick={handleSaveScrollTop} ref={handleMeasureHeight}>
      <div className={styles.header}>全部作者</div>
      {authorList.pagenation.count < 1 && <Blank load={authorList.load} />}
      <InfiniteScroll
        pageStart={1}
        loadMore={loadMore}
        hasMore={authorList.list.length < authorList.pagenation.count}
        loader={
          <div className="loader" key={0}>
            ----------加载中----------
          </div>
        }
        initialLoad={false}
        useWindow={false}
        getScrollParent={() => document.getElementById('container_content')}
      >
        <div className={styles.content}>
          {authorList.list.map((item, index) => {
            return (
              <div
                className={classNames(
                  index % 3 === 1 ? styles.content_author_mid : '',
                  styles.content_author,
                )}
                key={`${item.authorId}_${index}`}
              >
                <Author info={item} />
              </div>
            );
          })}
          {authorList.list.length >= authorList.pagenation.count &&
            authorList.pagenation.count > 12 && <></>}
        </div>
      </InfiniteScroll>
      <ScrollTop />
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          background: '#fff',
          height: '25px',
          zIndex: '1001',
          width: '830px',
          left: '200px',
        }}
      />
    </div>
  );
});
